import React from 'react';
export var Envelope = function Envelope(_a) {
  var className = _a.className;
  return React.createElement("svg", {
    className: className,
    width: "16",
    height: "16",
    viewBox: "0 0 48 48"
  }, React.createElement("path", {
    d: "M44.5,9.4h-41C1.6,9.4,0,10.9,0,12.8v22.5c0,1.9,1.6,3.4,3.5,3.4h41c1.9,0,3.5-1.5,3.5-3.4v-9.2V12.8\n    C48,10.9,46.4,9.4,44.5,9.4z M41.8,12.2L24,26.8l0,0l-0.1,0h0L6.2,12.2H41.8z M3.1,34.5V13.5L15.8,24L3.1,34.5z M6.2,35.7l11.4-9.4\n    l0.6-0.5l5,4.1c0.2,0.2,0.5,0.3,0.7,0.3c0.3,0,0.5-0.1,0.7-0.3l5-4.2l0.7,0.5l0,0l11.4,9.4H6.2z M44.9,34.5l-9.5-7.8L32.2,24\n    l12.7-10.5V34.5z"
  }));
};